import { useEffect, useState, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import { connect } from "react-redux";
import FormikControl from "../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
} from "../../../Types";
import { getDataListing, downloadJob } from "./DLMWiseBankDepositReportActions";
import Moment from "react-moment";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import storage from "../../../apis/Storage";
import { isPermittedPage } from "../../../apis/Utility";
import { formatDate } from "../../../utilities/FUNCTIONS";

const DLMWiseBankDepositReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));

  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);

  const [filterDistributorName, setFilterDistributorName] = useState(null);
  const [filterDistributionID, setFilterDistributionID] = useState(null);

  const [addJobDistributorsOptions, setAddJobDistributorsOptions] = useState([]);
  const [distCentersOptions, setDistCentersOptions] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [filter, setFilter] = useState({
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: "",
    isExport: false,
  });

  const columns = [
    { Header: "Distributor", accessor: "distributor" },
    { Header: "Distribution Center", accessor: "distributionCenter" },
    { Header: "Deliveryman Name", accessor: "deliverymanName" },
    { Header: "Cash Collected", accessor: "cashCollected" },
    { Header: "Bank Deposit", accessor: "bankDeposit" },
    { Header: "IBFT", accessor: "ibft" },
    { Header: "Total Deposit", accessor: "totalDeposit" },
    {
      Header: "Date",
      accessor: "depositDate",
      Cell: ({ value }) => <Moment format="DD/MM/YYYY">{value}</Moment>,
    },
  ];

  // -------------------- DATA FETCH -------------------- //
  useEffect(() => {
    props.getDropdownList("api/Distributor/GetDistributorsDDL", GET_DISTRIBUTOR_DDL);

    fetchReportData();

  }, [searchText]);

  // Distributor -> Distribution Center
  useEffect(() => {
    if (filterDistributorName?.value) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        {distributorIds: filterDistributorName.value} ,
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
      setFilterDistributionID(null); // reset DistributionID when Distributor changes
    } else {
      setDistCentersOptions([]);
      setFilterDistributionID(null);
    }
  }, [filterDistributorName]);

  // Map Redux distributor list to dropdown
  useEffect(() => {
    if (props.allDistributorList?.length) {
      if (userRights?.userType === "DistributorUser") {
        const filtered = props.allDistributorList.filter(
          (x) => x.value === userRights.distributorId
        );
        setAddJobDistributorsOptions(
          filtered.map((item) => ({ value: item.value, label: item.label }))
        );
        setFilterDistributorName({
          value: filtered[0]?.value,
          label: filtered[0]?.label,
        });
      } else {
        setAddJobDistributorsOptions(
          props.allDistributorList.map((item) => ({ value: item.value, label: item.label }))
        );
      }
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (props.selectedAddJobDistCentersList?.length) {
      let options = props.selectedAddJobDistCentersList.map((item) => ({
        value: item.value,
        label: item.label,
      }));

      // Apply DistributorUser restrictions if needed
      if (userRights?.userType === "DistributorUser" || userRights?.userType === "CoreAppUser") {
        const allowedIds = userRights.distCenterIds.split(",");
        options = options.filter((x) => allowedIds.includes(x.value));
      }

      setDistCentersOptions(options);
    } else {
      setDistCentersOptions([]);
    }
  }, [props.selectedAddJobDistCentersList, userRights]);

  // -------------------- FILTER REQUEST -------------------- //
  const formRequestObject = () => {
    const requestData = {
      distId:
        filterDistributorName?.value ||
        (userRights?.userType === "DistributorUser" ? userRights.distributorId : null),
      distCenterId: filterDistributionID?.value || null,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: filter.pageNo,
      searchText: searchText,
      isExport: filter.isExport,
    };
    return requestData;
  };

  const fetchReportData = (request) => {
    const finalRequest = request || formRequestObject();
    props.getDataListing(finalRequest);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    fetchReportData({ ...formRequestObject(), pageNo: page });
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    fetchReportData({ ...formRequestObject(), pageNo: 0, pageSize });
  };

  const searchChanged = (text) => setSearchText(text);

  const Download = () => props.downloadJob({ ...formRequestObject(), isExport: true });

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setFilterDistributorName(null);
    setFilterDistributionID(null);
    setFilter({
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: searchText,
      isExport: false,
    });
    setDistCentersOptions([]);
  };

  const applyFilters = () => {
    setCurrentPageNo(0);
    fetchReportData({ ...formRequestObject(), pageNo: 0 });
    setShow(false);
  };

  // -------------------- JSX -------------------- //
  return (
    <VzPageContainer title="DeliveryMan Wise Bank Deposit Report">
      <Row>
        <Col md={{ span: 10 }}>
          <h4>
            <b>DeliveryMan Wise Bank Deposit Report</b>
          </h4>
        </Col>
      </Row>

      {/* Filters & Export */}
      <Row>
        <Col md={10}>
          <div ref={ref}>
            <Button onClick={openFilterModal} className="m-3" variant="outline-primary">
              <i className="fa fa-filter" /> Filters
            </Button>

            <Overlay
              show={show}
              target={target}
              placement="bottom"
              container={ref}
              containerPadding={20}
            >
              <Popover id="popover-contained" style={{ maxWidth: "360px", width: "360px" }}>
                <Popover.Header as="h3">Filters</Popover.Header>
                <Popover.Body>
                  <Formik enableReinitialize initialValues={filter} onSubmit={applyFilters}>
                    {(formik) => (
                      <Form autoComplete="off">
                        <Row>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distributor Name"
                              name="distributorName"
                              options={addJobDistributorsOptions}
                              isSearchable
                              handleOnChange={(e) => {
                                if (!e) return;
                                setFilterDistributorName({ label: e.label, value: e.value });
                                setFilterDistributionID(null);
                              }}
                              value={filterDistributorName}
                            />
                          </Col>

                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distribution ID"
                              name="distributionID"
                              options={distCentersOptions}
                              isSearchable
                              handleOnChange={(e) => {
                                if (!e) return;
                                setFilterDistributionID({ label: e.label, value: e.value });
                              }}
                              value={filterDistributionID}
                            />
                          </Col>

                          <Col xs={12} md={6}>
                            <FormikControl
                              control="date"
                              label="From Date"
                              name="fromDate"
                              handleOnChange={(value) => setFilter({ ...filter, fromDate: value })}
                              value={filter.fromDate}
                            />
                          </Col>
                          <Col xs={12} md={6}>
                            <FormikControl
                              control="date"
                              label="To Date"
                              name="toDate"
                              handleOnChange={(value) => setFilter({ ...filter, toDate: value })}
                              value={filter.toDate}
                            />
                          </Col>
                        </Row>

                        <div className="row mt-3">
                          <div className="form-group w-100">
                            <Link onClick={() => handleResetFilters(formik.resetForm)} to="#" style={{ float: "left" }}>Reset</Link>
                            <Link onClick={() => setShow(false)} to="#" style={{ float: "right" }}>Cancel</Link>
                            <div className="float-right">
                              <Button type="submit" className="btn btn-primary" style={{ marginRight: 10 }}>Apply</Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>
        </Col>

        {isPermittedPage("Export", props.actions, props.userRole) && (
          <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={Download} className="m-3" variant="outline-primary">
              <i className="fa fa-download me-1" /> Export
            </Button>
          </Col>
        )}
      </Row>

      {/* DataTable */}
      <Row>
        <Col xs={12}>
          <ServerSideDataTable
            data={props.DLMWiseBankDepositReport?.data || []}
            columns={columns}
            totalRecords={props.DLMWiseBankDepositReport?.totalRecords || 0}
            goToPreviousPage={getData}
            goToNextPage={getData}
            pageSizeChange={pageSizeChanged}
            myPageSize={currentPageSize}
            pageNo={currentPageNo}
            searchChanged={searchChanged}
          />
        </Col>
      </Row>
    </VzPageContainer>
  );
};

//debugger;
const mapStateToProps = (state) => ({
  allDistributorList: state.ddlList.allDistributorList || [],
  selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList || [],
  DLMWiseBankDepositReport: state.DLMWiseBankDepositReport,
  userRole: storage.get("_appUserRole"),
});

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  getDataListing,
  downloadJob,
})(DLMWiseBankDepositReport);
